import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import {translate} from "../../../../../components/translate/translate.jsx";

const RegistrationContent = ({ data }) => {
    const register = (data?.actionsDistribution?.activation_actions ?? []).flatMap(item => item.actions ?? []);

    useEffect(() => {
        const values = [];
        const labels = [];

        const translatedRegister = register.map((element) => ({
            ...element,
            label: translate(element.label ?? element.text)
        }));

        translatedRegister.forEach((element) => {
            labels.push(element.label);
            values.push(element.qty);
        });

        GraphicUtils.horizontalStackedBarChart(translatedRegister, "sos-registration", "label");
    }, [register]);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">Cadastros</span>
                <div className="mt-1" id="sos-registration"/>
            </div>

            <div className="chart-divisor"/>
        </>
    );
};

export default RegistrationContent;